import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

/**
 * ConfirmModal - Reusable confirmation dialog component
 * Replaces native browser confirm() dialogs
 */
export default function ConfirmModal({
    isOpen,
    onClose,
    onConfirm,
    title = 'Confirmar acción',
    message,
    confirmText = 'Confirmar',
    cancelText = 'Cancelar',
    variant = 'danger' // 'danger' | 'warning' | 'info'
}) {
    if (!isOpen) return null;

    const variantStyles = {
        danger: {
            icon: 'text-red-400',
            button: 'bg-red-500 hover:bg-red-400'
        },
        warning: {
            icon: 'text-yellow-400',
            button: 'bg-yellow-500 hover:bg-yellow-400'
        },
        info: {
            icon: 'text-cyan-400',
            button: 'bg-cyan-500 hover:bg-cyan-400'
        }
    };

    const styles = variantStyles[variant] || variantStyles.danger;

    const handleConfirm = () => {
        onConfirm();
        onClose();
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 backdrop-blur-sm bg-black/60">
            {/* Overlay */}
            <div className="absolute inset-0" onClick={onClose}></div>

            {/* Modal */}
            <div className="relative bg-[#1a1a3e] rounded-2xl shadow-2xl border border-white/10 w-full max-w-md transform transition-all animate-scale-in">
                <div className="p-6">
                    {/* Icon and Title */}
                    <div className="flex items-start gap-4">
                        <div className={`flex-shrink-0 p-2 rounded-xl bg-white/5 ${styles.icon}`}>
                            <ExclamationTriangleIcon className="w-6 h-6" />
                        </div>
                        <div className="flex-1">
                            <h3 className="text-lg font-bold text-white mb-2">{title}</h3>
                            <p className="text-gray-400 text-sm whitespace-pre-line">{message}</p>
                        </div>
                    </div>
                </div>

                {/* Actions */}
                <div className="flex items-center justify-end gap-3 p-4 border-t border-white/10 bg-black/20 rounded-b-2xl">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 text-gray-400 hover:text-white transition-colors"
                    >
                        {cancelText}
                    </button>
                    <button
                        onClick={handleConfirm}
                        className={`px-4 py-2 text-white rounded-lg font-semibold transition-colors ${styles.button}`}
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
}
